export default function DownloadSection() {
  return (
    <section id="download" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            官方正版下载
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            选择您的设备平台，获取皇冠App官方正版安装包
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <div className="bg-background-100 border border-background-200/70 rounded-lg p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-5">
              <i className="ri-apple-fill text-5xl text-foreground-900" style={{ width: '64px', height: '64px' }}></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">iOS 版本</h3>
            <p className="text-sm text-foreground-600 mb-6">支持 iOS 14.0 及以上版本</p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 font-medium text-sm rounded-md hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-base w-4 h-4 flex items-center justify-center"></i>
              App Store 下载
            </a>
            <p className="text-xs text-foreground-400 mt-4">版本 v5.2.0 · 128MB · 2026年8月更新</p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-lg p-8 text-center relative overflow-hidden">
            <div className="absolute top-3 right-3">
              <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                推荐
              </span>
            </div>
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-5">
              <i className="ri-android-fill text-5xl text-accent-600" style={{ width: '64px', height: '64px' }}></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Android 版本</h3>
            <p className="text-sm text-foreground-600 mb-6">支持 Android 8.0 及以上版本</p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 font-medium text-sm rounded-md hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-base w-4 h-4 flex items-center justify-center"></i>
              APK 直接下载
            </a>
            <p className="text-xs text-foreground-400 mt-4">版本 v5.2.0 · 96MB · 2026年8月更新</p>
          </div>
        </div>

        <div className="mt-10 p-5 bg-accent-50 border border-accent-200/70 rounded-lg max-w-3xl mx-auto">
          <div className="flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-accent-600 text-base w-4 h-4 flex items-center justify-center"></i>
            </div>
            <div>
              <p className="text-sm text-accent-800 font-medium mb-1">安全下载提示</p>
              <p className="text-sm text-accent-700/80">
                请务必通过本官方网站下载皇冠App。切勿从第三方应用商店或不明链接下载，以免安装假冒或含有恶意代码的版本。安装前建议使用安全软件扫描安装包。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}